{
  "es": {
    "decision_type": {
      "actions": {
        "add_competitor": "Añadir competidor",
        "add_decision_partners": "Colaboradores de la decisión",
        "auto_share_proposals": "Compartir automáticamente las propuestas aprobadas",
        "change_rights": "Cambiar permisos",
        "collapse": "Contraer",
        "create_category": "Añadir nueva categoría",
        "delete": "Eliminar",
        "deleteMultiple": "Eliminar...",
        "delete_cancel": "Cancelar",
        "delete_group": "Eliminar grupo de colaboradores",
        "download": "Descargar",
        "edit": "Editar",
        "edit_decision_partners": "Editar colaboradores de la decisión",
        "import": "Importar",
        "manage": "Gestionar",
        "new": "Nuevo",
        "newDecision": "Nueva decisión",
        "newDecisions": "Decisión",
        "save": "Guardar",
        "show": "Mostrar",
        "start_new_group": "Iniciar nuevo grupo",
        "submit": "Guardar"
      },
      "attributes": {
        "category": "Categoría",
        "created_at": "Creado el",
        "description": "Descripción",
        "name": "Título",
        "responsible": "Responsable",
        "start_date": "Fecha de inicio"
      },
      "labels": {
        "add_decision_partners": "Añadir colaboradores de la decisión",
        "allowCreditExplainer": "Mostrar crédito para propuestas por debajo del presupuesto",
        "auto_close": "Cerrar la decisión automáticamente una vez superada la fecha límite",
        "auto_close_info": "Cerrar una decisión impide que el cliente apruebe una propuesta cuando no se ha tomado ninguna decisión. Esto es útil cuando trabajas con fechas límite ajustadas.",
        "auto_share": "Compartir automáticamente",
        "auto_share_description": "Comparte automáticamente las propuestas aprobadas con este grupo de colaboradores",
        "auto_share_subtitle": "Cuando se aprueba una nueva propuesta",
        "auto_share_title": "Compartir automáticamente las propuestas aprobadas",
        "category_name": "Nombre de la categoría",
        "closes_on_deadline": "Se cierra en la fecha límite",
        "createNewPartner": "O crea un nuevo colaborador de la decisión",
        "decision_type_category_description": "Asignar una categoría como cocina, baño, etc. a varias decisiones las agrupará y permitirá un mejor control",
        "deleteCategory": "¿Eliminar la categoría {category}?",
        "deleteGroupSubtitle": "Esto eliminará todas las conversaciones, propuestas y documentos creados por todos los miembros de {group_name} en {decision_type_name}.",
        "deleteGroupTitle": "Vas a eliminar {group_name}",
        "disclaimerDeleteGroup": "Eliminar {group_name} despublicará todas las decisiones para los colaboradores de la decisión. Podrás volver a publicar para los colaboradores de la decisión en cuanto esta decisión vuelva a tener colaboradores.",
        "disclamerDeleteCategory": "Eliminar {category} quitará la categoría de todas las decisiones asignadas a ella. Las decisiones no se eliminarán.",
        "editCategory": "Editar categoría",
        "editGroup": "Editar {group_name}",
        "editPartnerRights": "Editar permisos de comunicación del colaborador de la decisión",
        "editPartnerRightsLater": "Siempre puedes cambiar esto más tarde",
        "edit_partner_group_eyebrow": "Editar grupo de colaboradores",
        "existing_groups": "Grupos de colaboradores existentes",
        "explainerPartners": "Añade colaboradores externos de la decisión y trabaja junto a ellos en {decision_type_name}",
        "export_preparing": "Recopilar todas las propuestas puede tardar unos minutos. Recibirás una notificación cuando esté lista para descargar.",
        "export_proposals_approved": "Documentos de propuestas aprobadas",
        "for_decision": "Para la decisión",
        "groupRightsWarning": "¡Aviso! Se eliminarán todas las conversaciones entre el cliente y los colaboradores. Esta acción es irreversible. ¿Seguro que quieres continuar?",
        "hint": "Puedes gestionar tus categorías en la",
        "hintSettings": "configuración de la organización.",
        "last_updated_at": "Última actualización el",
        "matrix": "Estadísticas",
        "new_category": "Nueva categoría de decisión",
        "new_partner_group": "Nuevo grupo de colaboradores",
        "noPartnersAddedYet": "Aún no se han añadido colaboradores de la decisión",
        "noResultPartner": "Sin resultados para {partner_name}",
        "partner_already_in_other_group": "Ya está en otro grupo",
        "partner_already_selected": "Ya seleccionado",
        "partner_group": "Grupo de colaboradores",
        "partner_group_footer_empty": "Selecciona al menos 1 colaborador",
        "partner_group_footer_summary": "{count} colaborador • {rights} | {count} colaborador • {rights} | {count} colaboradores • {rights}",
        "partner_group_name_label": "Nombre del grupo de colaboradores",
        "partner_groups": "Grupos de colaboradores",
        "partners": "Colaboradores de la decisión",
        "partners_count": "Sin colaboradores | 1 colaborador | {count} colaboradores",
        "partners_in_group": "Colaboradores en este grupo",
        "partners_in_total": "Sin colaboradores en total | 1 colaborador en total | {count} colaboradores en total",
        "partners_selected_count": "Ninguno seleccionado | 1 seleccionado | {count} seleccionados",
        "permissions_label": "Permisos del grupo",
        "projectUnitsTotal": "{project_name} tiene {units_count_max} unidades en total",
        "proposal_uploaded": "propuesta subida",
        "published_state": "Estado de publicación",
        "searchPartners": "Buscar por nombre u organización",
        "selectADecision": "Selecciona una decisión",
        "select_decision_partners": "Selecciona tus colaboradores de la decisión",
        "setUpPartners": "Configurar colaboradores de la decisión",
        "set_rights": "Establecer permisos del grupo para {partner_group_name}",
        "share_existing_title": "Compartir propuestas existentes",
        "share_proposals_label": "Compartir propuestas",
        "start_date_description": "Fecha solo para uso interno. Se puede usar para determinar el orden en que tu equipo trabaja las decisiones",
        "start_date_title": "Fecha de inicio (opcional)",
        "step0Title": "¿Qué proyecto de plantilla y decisión quieres usar?",
        "step1Title": "¿Qué tipo de decisión tienen que tomar tus clientes?",
        "tab_proposal_templates": "Plantillas de propuestas",
        "tab_units": "Unidades",
        "upsellCategoryTypes": "Esta función no está incluida en tu paquete. Contáctanos a través del botón azul para saber más.",
        "view": "Ver",
        "view_list": "Lista",
        "view_table": "Tabla",
        "writeEmployeeNameReject": "Escribe <i><b>{employeeName}</b></i> para continuar."
      },
      "snackbars": {
        "duplicate": "La decisión se ha creado, aunque el proceso de copia desde la plantilla puede tardar unos minutos en completarse."
      },
      "toasts": {
        "bulk_delete": "Decisión eliminada correctamente | Decisiones eliminadas correctamente",
        "update": "Decisión actualizada correctamente"
      },
      "validation": {
        "duplicateNameAlreadyTaken": "'{name}' ya está en uso en este proyecto",
        "nameAlreadyTaken": "El nombre ya está en uso en este proyecto",
        "needName": "El título es obligatorio",
        "projectRequired": "Selecciona primero un proyecto",
        "selectDecisionType": "Selecciona al menos 1 decisión",
        "selectSharingOption": "Selecciona con quién quieres compartir el/los documento(s)"
      }
    }
  }
}
